import { render, staticRenderFns } from "./flavor-add.vue?vue&type=template&id=e3f54042&"
import script from "./flavor-add.vue?vue&type=script&lang=js&"
export * from "./flavor-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3f54042')) {
      api.createRecord('e3f54042', component.options)
    } else {
      api.reload('e3f54042', component.options)
    }
    module.hot.accept("./flavor-add.vue?vue&type=template&id=e3f54042&", function () {
      api.rerender('e3f54042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/flavor/flavor-add.vue"
export default component.exports